/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * See https://cloud.google.com/billing/reference/rest/v1/billingAccounts#BillingAccount for documentation on name, displayName, and open.
 * @export
 * @interface BillingAccount
 */
export interface BillingAccount {
    /**
     * Returns true if this is the billing account used for free tier
     * @type {boolean}
     * @memberof BillingAccount
     */
    freeTier: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillingAccount
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAccount
     */
    displayName: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingAccount
     */
    open: boolean;
}

/**
 * Check if a given object implements the BillingAccount interface.
 */
export function instanceOfBillingAccount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "freeTier" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "open" in value;

    return isInstance;
}

export function BillingAccountFromJSON(json: any): BillingAccount {
    return BillingAccountFromJSONTyped(json, false);
}

export function BillingAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'freeTier': json['freeTier'],
        'name': json['name'],
        'displayName': json['displayName'],
        'open': json['open'],
    };
}

export function BillingAccountToJSON(value?: BillingAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'freeTier': value.freeTier,
        'name': value.name,
        'displayName': value.displayName,
        'open': value.open,
    };
}

